import { Navigate } from 'react-router-dom';
import { useIsAdmin } from '@/hooks/useAdmin';
import LoadingPage from '@/components/ui/LoadingPage';

/**
 * Sends each role to its own home. Login always lands on `/`, so putting the decision
 * here keeps the sign-in flow unaware of roles.
 */
export function HomeRedirect() {
  const { isAdmin, isLoading } = useIsAdmin();

  if (isLoading) return <LoadingPage />;

  return <Navigate to={isAdmin ? '/admin' : '/patients'} replace />;
}
